/**
 * Friendly time helpers — turn "13:30" into "1:30 PM" and so on.
 */

export function formatHourLabel(hhmm) {
  if (!hhmm || !hhmm.includes(":")) return hhmm || "";
  const [h, m] = hhmm.split(":").map(Number);
  const period = h >= 12 ? "PM" : "AM";
  const hh = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return `${hh}:${String(m).padStart(2, "0")} ${period}`;
}

export function friendlyDayPart(hhmm) {
  if (!hhmm || !hhmm.includes(":")) return "";
  const h = Number(hhmm.split(":")[0]);
  if (h < 12) return "morning";
  if (h < 17) return "afternoon";
  return "evening";
}

// Build a Date in user's local timezone for a given calendar Date object + "HH:MM" string
export function dateAtHour(date, hhmm) {
  const [h, m] = hhmm.split(":").map(Number);
  const d = new Date(date);
  d.setHours(h, m, 0, 0);
  return d;
}

export function isSameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function isHourPast(date, hhmm) {
  return dateAtHour(date, hhmm).getTime() <= Date.now();
}
